import HttpRequestService from "../../serviceLayer/httpProtocol/HttpRequestService";
import TargetApiUrlAndPath from "../../utils/webApi/TargetApiUrlAndPath";
import QuestionnaireName from "../../utils/enumerations/QuestionnaireName";
import OrderType from "../../utils/stringLiterals/OrderType";
import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";
import HttpStatusCode from "../../utils/httpProtocol/HttpStatusCode";



const getQuestionnaire = function(getQuestionnaireCallback){
    const url = HttpRequestService.getUrl(TargetApiUrlAndPath.API_QUESTIONNAIRE_PATH );
    const questionnaireName = QuestionnaireName[QuestionnaireName.Character_structure_Wilhelm_Reich];
    const orderType = OrderType.randomized;
    const completeUrl = url+"/"+questionnaireName +"/"+orderType;
    HttpRequestService.GETMethod (completeUrl, (httpResponse)=>{
        processGetQuestionnaireHttpResponseCallback(httpResponse);
        getQuestionnaireCallback(httpResponse);
    });
}

const getResponseReport = function(getResponseReportCallback){
    const url = HttpRequestService.getUrl(TargetApiUrlAndPath.API_RESPONSE_REPORT_PATH );

    HttpRequestService.GETMethod (url, (httpResponse)=>{
        processGetResponseReportHttpResponseCallback(httpResponse);
        getResponseReportCallback(httpResponse);
    });
}

const processDisplayOnQuestionnairePageReverse = function(pageInfo, randomizedQuestionnaire){
     const selectedPageIndex = (pageInfo.pageNumber - 1) * pageInfo.limitPerPage;
     const topLimit = selectedPageIndex + pageInfo.limitPerPage;
     const topLimitIndex = (topLimit > randomizedQuestionnaire.length) ? randomizedQuestionnaire.length - 1: topLimit-1;

     for(let i = topLimitIndex;  i >= selectedPageIndex ; i--){
         randomizedQuestionnaire[i].display = pageInfo.isOnDisplay;
     }

     return randomizedQuestionnaire;
}

const processDisplayOnQuestionnairePageForward = function(pageInfo, randomizedQuestionnaire){
    const selectedPageIndex = (pageInfo.pageNumber - 1) * pageInfo.limitPerPage;
    const topLimit = selectedPageIndex + pageInfo.limitPerPage;
    const topLimitIndex = (topLimit > randomizedQuestionnaire.length) ? randomizedQuestionnaire.length: topLimit;

    for(let i = selectedPageIndex; i< topLimitIndex; i++){
        randomizedQuestionnaire[i].display = pageInfo.isOnDisplay;
    }

    return randomizedQuestionnaire;
}

const getUpdatedQuestionnaireOnCheckboxChange = function (questionID ,choiceID,  allQuestions){
    let updatedQuestionnaire = allQuestions.map((obj)=>{return obj});
    const foundQuestion = updatedQuestionnaire.find((question)=>{
        return (question.QuestionID === questionID)
    });

    if(foundQuestion){
        let allChoices = foundQuestion.choices;
        for(let i = 0; i < allChoices.length; i++){
            if(allChoices[i].ChoiceID === choiceID){
                allChoices[i].checked = true;
            }else{
                allChoices[i].checked = false;
            }
        }
    }

    return updatedQuestionnaire;
}

const submitQuestionnaireSelectedChoices = function(questionnaireSubmissionCallback){
    const url = HttpRequestService.getUrl(TargetApiUrlAndPath.API_QUESTIONNAIRE_SUBMISSION_PATH );
    let payload = {};
    payload.questionnaireResponses = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.QuestionnaireUserResponses);
    payload.questionnaireName = QuestionnaireName[QuestionnaireName.Character_structure_Wilhelm_Reich];

    HttpRequestService.POSTMethod (url, payload, (httpResponse)=>{
        //processSubmitQuestionnaireSelectedChoicesResponseCallback(httpResponse);
        questionnaireSubmissionCallback(httpResponse);
    });
}


//#region Private Functions BEGIN

function processGetQuestionnaireHttpResponseCallback(httpResponse){
    //console.log("processGetQuestionnaireHttpResponseCallback-httpResponse", httpResponse);
    const randomizedQuestionsArray = httpResponse.payload.questionnaire[0].sections[0].randomizedQuestions;
    //console.log("randomizedQuestionsArray", randomizedQuestionsArray);
    const allUncheckedRandomizedQuestions = markAllChoicesAsUnchecked(randomizedQuestionsArray);
    const allSplitChoicesRandomizedQuestions = splitOrderInAllchoices(allUncheckedRandomizedQuestions);
    const allHiddenRandomizedQuestions = setAllQuestionsAsHidden(allSplitChoicesRandomizedQuestions);
    LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.originalRandomizedQuestionnaire,allHiddenRandomizedQuestions);
    LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.QuestionnaireUserResponses,allHiddenRandomizedQuestions);
}

function processGetResponseReportHttpResponseCallback(httpResponse){
    //console.log("processGetResponseReportHttpResponseCallback-httpResponse", httpResponse);
    if(httpResponse.code === HttpStatusCode._200ok.code){
        const payload = httpResponse.payload;
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.allCharacterTypeColors, payload.allCharacterTypeColors);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.allCharacterTypeNames, payload.allCharacterTypeNames);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.allCharacterTypesDataPoints, payload.allCharacterTypesDataPoints);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.allQuestionnaireResponseDataPoints, payload.allQuestionnaireResponseDataPoints);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.allScatterChartDataPoints, payload.allScatterChartDataPoints);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.mostTwoDominantCharacterTypes, payload.mostTwoDominantCharacterTypes);
    }
}

function setAllQuestionsAsHidden(allQuestions){
    let questions = allQuestions.map((obj)=>{return obj});
    //console.log("setAllQuestionsAsHidden-allQuestions", allQuestions);
    //console.log("setAllQuestionsAsHidden-questions", questions);
    for(let i=0; i< questions.length; i++){
        questions[i].display = false;
    }
    return questions;
}

function markAllChoicesAsUnchecked(allQuestions){

    let questions = allQuestions.map((obj)=>{ return obj});
    //console.log("markAllChoicesAsUnchecked-allQuestions", allQuestions);
    //console.log("markAllChoicesAsUnchecked-questions", questions);
    questions.forEach((question)=>{
        let allChoices = question.choices;
        for(let i = 0; i< allChoices.length; i++){
            allChoices[i].checked = false;            
        }
    });

    return questions;
}

function splitOrderInAllchoices(allQuestions){
    
    let questions = allQuestions.map((obj)=>{ return obj});
    //console.log("markAllChoicesAsUnchecked-allQuestions", allQuestions);
    //console.log("markAllChoicesAsUnchecked-questions", questions);
    questions.forEach((question)=>{
        let allChoices = question.choices;
        for(let i = 0; i< allChoices.length; i++){
            const words = allChoices[i].Text.split(/\)(.*)/s); 
            allChoices[i].choiceOrder = words[0] +')';
            allChoices[i].Text = words[1];
        }
    });

    return questions;
}



//#region Private Functions END

const QuestionnaireManager = Object.freeze({
    getQuestionnaire : getQuestionnaire,
    processDisplayOnQuestionnairePageReverse : processDisplayOnQuestionnairePageReverse,
    processDisplayOnQuestionnairePageForward : processDisplayOnQuestionnairePageForward,
    getUpdatedQuestionnaireOnCheckboxChange : getUpdatedQuestionnaireOnCheckboxChange,
    submitQuestionnaireSelectedChoices : submitQuestionnaireSelectedChoices,
    getResponseReport : getResponseReport
});

export default QuestionnaireManager;